import axios from 'axios'

import environment from '@/environment'

export const NORDPOOL_TRADE_ADAPTER_API_URL = environment.services.nordpoolTradeAdapterApiUrl

export const importTrade = async (file: File): Promise<void> => {
  // As we send a multipart/form-data post request, we need to create the payload using the FormData API.
  const formData = new FormData()
  formData.append('body', file)
  const url = `${NORDPOOL_TRADE_ADAPTER_API_URL}/trades/import`

  await axios.post<void>(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
